import React from 'react'
import {
  niceIso8601String,
  formattedDuration,
  niceBlockedMessage,
  formatStat,
} from '../../shared'
import AdminEditItemLink from './AdminEditItemLink'
import AdminPostListen from './AdminPostListen'
import TextPart from './TextPart'
import UserLink from './UserLink'
import { Cell } from '../../components'

const AdminPostCell = ({post, noline, children}) => {
  return (
    <Cell noline={noline}>
      <Cell.Image src={post.signed_image_urls['400']} alt='' large />
      <Cell.Body>
        <Cell.Line>
          <Cell.LineTitle>
            <AdminEditItemLink item_name={post.title} item_type={'POST'} item_id={post.id} />
          </Cell.LineTitle>
          {post.derank_reason && <Cell.LineImportant><div>Deranked: {post.derank_reason}</div></Cell.LineImportant>}
          {post.is_blocked && <Cell.LineImportant>{niceBlockedMessage(post.is_blocked)}</Cell.LineImportant>}
          {!post.is_blocked && post.is_featured && <Cell.LineFeatured />}
          {post.pinned && <Cell.LinePinned />}
        </Cell.Line>

        <Cell.Line>
          <UserLink user_id={post.user_id} username={post.user_name} />
          {post.collaborators && post.collaborators.length > 0 && <span>
            (
              {post.collaborators.map((collaborator, index) => <UserLink key={index} user_id={collaborator.user_id} username={collaborator.username} />).reduce((prev, curr) => [prev, ', ', curr])}
            )
          </span>}
          {post.user_country && <span>({post.user_country}{post.source === 'amn' ? ' - Local' : ''})</span>}
        </Cell.Line>

        {post.description && <Cell.Line>
          {post.description_parts ? post.description_parts.map((part, index) => <TextPart key={index} part={part} />) : post.description}
        </Cell.Line>}

        {post.is_description_blocked && <Cell.LineNotice>(Description blocked)</Cell.LineNotice>}

        <Cell.Line>
          <div>{formattedDuration(post.duration_seconds)}</div>
          <div>{niceIso8601String(post.created_at)}</div>
        </Cell.Line>

        {<Cell.Line>
          {<Cell.PlayCount>{formatStat(post.play_count)}</Cell.PlayCount>}
          {<Cell.LikeCount>{formatStat(post.like_count)}</Cell.LikeCount>}
          {<Cell.CommentCount>{formatStat(post.comment_count)}</Cell.CommentCount>}
        </Cell.Line>}

        {post.genre && <Cell.Line>
          <Cell.MusicNote>{post.genre}</Cell.MusicNote>
        </Cell.Line>}

        <Cell.Line>
          {post?.beat?.beat_name &&
            <Cell.MusicNote>{post?.beat?.beat_name}</Cell.MusicNote>
          }
        </Cell.Line>

        <Cell.Line>
          <AdminPostListen post={post} />
        </Cell.Line>
      </Cell.Body>

      {children}
    </Cell>
  )
}

AdminPostCell.ModerationActions = ({pendingCount, reviewedCount, onDetails, onAllow, onBlock}) =>
  <Cell.Actions>
    <Cell.Button onClick={onDetails}>
      {pendingCount} / {pendingCount+reviewedCount}
    </Cell.Button>
    <Cell.Button onClick={onAllow}>
      Allow
    </Cell.Button>
    <Cell.Button onClick={onBlock}>
      Block
    </Cell.Button>
  </Cell.Actions>

AdminPostCell.FeatureActions = ({post, onFeatureClick}) => {
  var actions = null
  if (post.is_featured) {
    actions = onFeatureClick && <Cell.Button onClick={() => onFeatureClick(post)}>Unfeature</Cell.Button>
  } else {
    actions = <>
      {onFeatureClick && <Cell.Button onClick={() => onFeatureClick(post)}>Feature</Cell.Button>}
    </>
  }
  return <Cell.Actions>
    {actions}
  </Cell.Actions>
}

AdminPostCell.EditActions = ({post, onFeature, onDerank, onBlockImage, onConvertToBeat, onRunAcrCloud}) => <Cell.Actions>
  {onFeature && <Cell.Button onClick={onFeature}>{post.is_featured ? 'Unfeature' : 'Feature'}</Cell.Button>}
  {onDerank && <Cell.Button onClick={onDerank}>{post.derank_reason ? 'Remove Derank' : 'Derank'}</Cell.Button>}
  {onBlockImage && <Cell.Button onClick={onBlockImage}>{post.is_image_blocked ? 'Unblock Image' : 'Block Image'}</Cell.Button>}
  {onConvertToBeat && <Cell.Button onClick={onConvertToBeat}>Convert to Beat</Cell.Button>}
  {onRunAcrCloud && <Cell.Button onClick={onRunAcrCloud}>Run ACR Cloud</Cell.Button>}
</Cell.Actions>

export default AdminPostCell
